//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, onMounted } from '@vue/composition-api'
import { useRouter, defaultDownloadAppByOS } from '@core/utils'
import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'
import { mdiDeleteForever, mdiCloseCircleOutline } from '@mdi/js'

export default {
  setup() {
    const { router, route } = useRouter()
    const { t } = useUtils()

    const isInactive = ref(false)
    const isInvalid = ref(false)

    const onSearchVideos = () => {
      router.push({ name: 'views-facility-list' })
    }

    onMounted(() => {
      const { inactive, invalid } = route.value.params
      isInactive.value = inactive
      isInvalid.value = invalid
    })

    return {
      // data
      isInactive,
      isInvalid,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitleBlack,

      defaultDownloadAppByOS,
      onSearchVideos,
      t,

      icons: {
        mdiDeleteForever,
        mdiCloseCircleOutline,
      },
    }
  },
}
